export default "__VITE_ASSET__M4rmoO$p__"